(() => {
  const BUTTON = '.boost-sd__pagination-load-more-container-item .boost-sd__pagination-button';
  const ITEM = '.boost-sd__product-item';
  const LOADING_TIMEOUT = 15000;

  let loadingBtn = null;
  let itemsAtClick = 0;
  let loadingTimer = null;
  let lastClickWasPrevious = false;
  let offset = null;
  let uniqueAtClick = 0;
  let firstId = null;
  let lastPage = 0;
  let requestedPage = 0;
  let clickingProduct = false;

  const itemCount = () => document.querySelectorAll(ITEM).length;
  const uniqueCount = () => new Set([...document.querySelectorAll(ITEM)].map((card) => card.dataset.productId)).size;
  const toInt = (s) => parseInt(String(s).replace(/,/g, ''), 10);

  function setLoading(btn) {
    loadingBtn = btn;
    itemsAtClick = itemCount();
    uniqueAtClick = uniqueCount();
    lastClickWasPrevious = btn.classList.contains('boost-sd__pagination-button--load-previous');
    requestedPage = 0;
    if (offset === null) {
      const counter = readCounter();
      if (counter && counter.start > 1) {
        offset = counter.start - 1;
        lastPage = toInt(new URLSearchParams(location.search).get('page')) || 1;
      }
    }
    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');
    btn.setAttribute('aria-disabled', 'true');
    clearTimeout(loadingTimer);
    loadingTimer = setTimeout(clearLoading, LOADING_TIMEOUT);
  }

  function clearLoading() {
    clearTimeout(loadingTimer);
    if (!loadingBtn) return;
    loadingBtn.classList.remove('is-loading');
    loadingBtn.removeAttribute('aria-busy');
    loadingBtn.removeAttribute('aria-disabled');
    loadingBtn = null;
  }

  document.addEventListener('click', (event) => {
    const btn = event.target.closest(BUTTON);
    if (!btn) return;
    if (loadingBtn) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }
    setLoading(btn);
  }, true);

  const nativeFetch = window.fetch;
  window.fetch = function (input, init) {
    if (loadingBtn && !lastClickWasPrevious && offset !== null && typeof input === 'string' && input.includes('/bc-sf-filter/filter')) {
      const url = new URL(input, location.href);
      requestedPage = lastPage + 1;
      url.searchParams.set('page', requestedPage);
      input = url.toString();
    }
    return nativeFetch.call(this, input, init);
  };

  ['pushState', 'replaceState'].forEach((method) => {
    const native = history[method];
    history[method] = function (state, title, url) {
      if (offset !== null && (loadingBtn || clickingProduct) && url != null) {
        const next = new URL(url, location.href);
        const page = loadingBtn && !lastClickWasPrevious ? lastPage + 1 : lastPage;
        if (page > 1) next.searchParams.set('page', page);
        else next.searchParams.delete('page');
        url = next.pathname + next.search + next.hash;
      }
      return native.call(this, state, title, url);
    };
  });

  function readCounter() {
    const counters = [
      ...document.querySelectorAll('.boost-sd__product-count:not([data-position="bottom"]):not(.liw-product-count)'),
      ...document.querySelectorAll('.boost-sd__product-count[data-position="bottom"]'),
    ];
    for (const counter of counters) {
      const match = counter.textContent.match(/([\d,]+)\s*-\s*([\d,]+)\s*of\s*([\d,]+)/i);
      if (!match) continue;
      const [start, end, total] = [match[1], match[2], match[3]].map(toInt);
      return { start, end, total };
    }
    return null;
  }

  function readProgress() {
    const counter = readCounter();
    if (!counter) return null;
    const viewed = offset !== null
      ? offset + uniqueCount()
      : Math.max(counter.end, counter.start - 1 + itemCount());
    return { viewed, total: counter.total };
  }

  function renderProgress() {
    const list = document.querySelector('.boost-sd__product-list');
    const progress = readProgress();
    let el = document.querySelector('.liw-load-progress');

    if (!list || !progress || !progress.total) {
      if (el) el.hidden = true;
      return;
    }

    if (!el) {
      el = document.createElement('div');
      el.className = 'liw-load-progress';
      el.innerHTML = '<p class="liw-load-progress__text" aria-live="polite"></p>'
        + '<div class="liw-load-progress__track" aria-hidden="true"><div class="liw-load-progress__bar"></div></div>';
    }
    if (el.previousElementSibling !== list) list.after(el);
    el.hidden = false;

    const viewed = Math.min(progress.viewed, progress.total);
    const noun = progress.total === 1 ? 'product' : 'products';
    const text = `Showing <strong>${viewed}</strong> of <strong>${progress.total}</strong> ${noun}`;
    const textEl = el.querySelector('.liw-load-progress__text');
    if (textEl.innerHTML !== text) textEl.innerHTML = text;
    el.querySelector('.liw-load-progress__bar').style.width = `${(viewed / progress.total) * 100}%`;
  }

  function renderCount() {
    const counter = document.querySelector('.boost-sd__product-count:not([data-position="bottom"]):not(.liw-product-count)');
    let own = document.querySelector('.liw-product-count');
    const range = counter && readCounter();
    const progress = range && readProgress();
    if (counter) counter.style.display = progress ? 'none' : '';
    if (!progress) {
      if (own) own.remove();
      return;
    }
    if (!own) {
      own = document.createElement(counter.tagName);
      own.className = `${counter.className} liw-product-count`;
    }
    if (own.previousElementSibling !== counter) counter.after(own);
    const start = offset !== null ? offset + 1 : range.start;
    const text = `${start} - ${Math.min(progress.viewed, progress.total)} of ${progress.total} ${progress.total === 1 ? 'product' : 'products'}`;
    if (own.textContent !== text) own.textContent = text;
  }

  function sync() {
    const count = itemCount();
    const first = document.querySelector(ITEM)?.dataset.productId || null;
    if (loadingBtn && count !== itemsAtClick) {
      if (lastClickWasPrevious && offset !== null) offset = Math.max(0, offset - (uniqueCount() - uniqueAtClick));
      else if (requestedPage) lastPage = requestedPage;
    } else if (!loadingBtn && first !== firstId) {
      offset = null;
    }
    firstId = first;
    if (loadingBtn && (count !== itemsAtClick || !loadingBtn.isConnected)) clearLoading();
    renderProgress();
    renderCount();
  }

  let frame = 0;
  new MutationObserver(() => {
    if (frame) return;
    frame = requestAnimationFrame(() => {
      frame = 0;
      sync();
    });
  }).observe(document.body, { childList: true, subtree: true, characterData: true });

  sync();

  const POSITION_KEY = 'liw-boost-back-position';
  let openedProduct = false;

  document.addEventListener('click', (event) => {
    const card = event.target.closest(`${ITEM} a[href*="/products/"]`)?.closest(ITEM);
    if (!card) return;
    openedProduct = true;
    clickingProduct = true;
    setTimeout(() => { clickingProduct = false; });
    try {
      sessionStorage.setItem(POSITION_KEY, JSON.stringify({ id: card.dataset.productId, top: card.getBoundingClientRect().top }));
    } catch (e) { /* storage unavailable — Boost's own restore still runs */ }
  }, true);

  window.addEventListener('pagehide', () => {
    if (!openedProduct) return;
    openedProduct = false;
    try { sessionStorage.setItem('boostSDSelectedProductId', 'null'); } catch (e) { /* ignore */ }
  });

  function restorePosition() {
    let saved = null;
    try {
      saved = JSON.parse(sessionStorage.getItem(POSITION_KEY));
      sessionStorage.removeItem(POSITION_KEY); // one-shot: never pull a later visit back here
    } catch (e) { return; }
    if (!saved || !saved.id) return;

    let stopped = false;
    const stop = () => { stopped = true; };
    ['wheel', 'touchstart', 'keydown', 'mousedown'].forEach((type) => window.addEventListener(type, stop, { once: true, passive: true }));

    const start = performance.now();
    let lastMove = start;
    (function pin(now) {
      if (stopped || now - start > 8000) return;
      const card = document.querySelector(`${ITEM}[data-product-id="${saved.id}"]`);
      if (card) {
        const header = document.querySelector('.site-header');
        const target = Math.max(saved.top, header ? header.getBoundingClientRect().bottom : 0);
        const drift = Math.round(card.getBoundingClientRect().top - target);
        if (Math.abs(drift) > 1) {
          window.scrollBy({ top: drift, behavior: 'instant' });
          lastMove = now;
        } else if (now - lastMove > 1500) {
          return;
        }
      }
      requestAnimationFrame(pin);
    })(start);
  }

  const nav = performance.getEntriesByType('navigation')[0];
  if (nav && nav.type === 'back_forward') restorePosition();
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) restorePosition();
  });
})();
